<script>
export default {
    render() {
      return (
          <nav>
            <ul v-for="(vnode, key) in $slots.default" class="breadcrumb-list">
              {this.$slots.default.map((vnode) => (
                <li>{vnode}</li>
              ))}
            </ul>
          </nav>
      )
    },
}
</script>
<style scoped>
.breadcrumb-list {
  display: flex;
}
.breadcrumb-list li {
  font-size: 1.25rem;
  position: relative;
}
.breadcrumb-list li:after {
  margin: 0 .8em;
  vertical-align: middle;
  font-size: 0.875rem;
  font-family: 'Font Awesome 5 Free';
  content: "\f105";
  font-weight: 900;
}
.breadcrumb-list li:last-of-type:after {
  display: none;
}
/* .breadcrumb-list li .add-icon {
  position: absolute;
  display: inline-block;
  top: 50%;
  right: -30px;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  font-size: 0;
  color: #fff;
  background: #f5c44b;
  border-radius: 12px;
  text-decoration: none;
}
.breadcrumb-list li .add-icon:before {
  font-family: 'Font Awesome 5 Free';
  content: "\f067";
  font-weight: 900;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 1.7rem; */
/* } */

</style>
